import { useEffect, useState } from "react";
import { api } from "../../lib/api";

const Card = ({ label, value, hint, testid }) => (
  <div className="rounded-2xl border border-[#7DC4E8] bg-white p-4" data-testid={testid}>
    <p className="text-[11px] font-semibold uppercase tracking-wider text-[#0369A1]">{label}</p>
    <p className="mt-1 font-display text-2xl font-bold text-[#0C4A6E]">{value}</p>
    {hint && <p className="mt-0.5 text-xs text-slate-500">{hint}</p>}
  </div>
);

export function RelanceStats({ refreshKey }) {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/plaquette/relances/stats").then(({ data }) => setS(data)).catch(() => setS(null)); }, [refreshKey]);
  if (!s) return null;
  const { auto, manuel } = s.par_mode;
  return (
    <div className="mt-4 grid gap-3 sm:grid-cols-4" data-testid="relance-stats">
      <Card label="Prospects relancés" value={s.relances} hint={`dont ${s.relances2 || 0} seconde${s.relances2 > 1 ? "s" : ""} relance${s.relances2 > 1 ? "s" : ""}`} testid="relance-stats-total" />
      <Card label="Démos demandées" value={s.convertis} hint={`dans les ${s.fenetre_jours} jours suivant la relance`} testid="relance-stats-convertis" />
      <Card label="Taux de conversion" value={`${String(s.taux).replace(".", ",")} %`} testid="relance-stats-taux" />
      <Card label="Automatique / manuelle" value={`Auto ${auto.convertis}/${auto.relances} · Manuelle ${manuel.convertis}/${manuel.relances}`} hint="démos / relances" testid="relance-stats-modes" />
    </div>
  );
}
